import { Endpoints, urlBuilder } from '@/connectors/endpoints'
import { mapper } from '@/mappers'
import { managingOrganizationMap } from '@/mappers/user'
import AxiosRequestBuilder from '@/utils/axios-request-builder'
import { IManagingOrganization } from '@/types/user'

const showManOrg = (moid: number, payment: number, houses: number) => {
  return new AxiosRequestBuilder<IManagingOrganization>({
    url: urlBuilder(Endpoints.SHOW_MAN_ORG, String(moid), String(payment), String(houses)),
    method: 'get',
    responseMapperFunction: mapper,
    responseMapper: managingOrganizationMap
  }).exec().then((response) => response.data)
}

export default showManOrg
